import React from "react";

import "./HallOffFame.css";

import {

    Crown,

    Star,

    Shield,

    Award,

    Trophy

} from "lucide-react";

const HallOfFame=()=>{

    const requirements=[

        {

            title:"Reach Elite Level",

            icon:<Crown size={22}/>,

            completed:false

        },

        {

            title:"Unlock All Achievements",

            icon:<Award size={22}/>,

            completed:false

        },

        {

            title:"Earn 5000 XP",

            icon:<Star size={22}/>,

            completed:false

        },

        {

            title:"Maintain 100 Day Streak",

            icon:<Shield size={22}/>,

            completed:false

        }

    ];

    return(

        <div className="hall-card">

            <div className="hall-header">

                <div>

                    <h2>

                        Hall Of Fame

                    </h2>

                    <p>

                        Become an Ignite Legend by completing every milestone.

                    </p>

                </div>

                <Trophy size={34}/>

            </div>

            <div className="hall-grid">

                {

                    requirements.map(

                        (item,index)=>(

                            <div

                                key={index}

                                className="hall-item"

                            >

                                <div className="hall-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h4>

                                        {item.title}

                                    </h4>

                                    <span>

                                        {

                                            item.completed

                                            ?

                                            "Completed"

                                            :

                                            "Locked"

                                        }

                                    </span>

                                </div>

                            </div>

                        )

                    )

                }

            </div>

            <div className="hall-footer">

                <div className="legend-badge">

                    👑

                </div>

                <div>

                    <h3>

                        Ignite Legend

                    </h3>

                    <p>

                        Unlock every achievement to enter the Hall of Fame.

                    </p>

                </div>

            </div>

        </div>

    );

};

export default HallOfFame;